import React, { Suspense } from "react";
import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import Layout from "layout";
import { AxiosInterceptor } from 'helpers/api';
import AuthGuard from "components/security/AuthGuard";

import Intro from "views/intro";

import Login from "views/login";
import Validate from "views/validate";

import Homepage from "views/home";

import OwnedAssets from "views/asset/owned";
import AssetDetails from "views/asset/details";
import AssetPickup from "views/asset/pickup";
import ReturnAsset from "views/asset/return";
import AssetReview from "views/asset/review";
import AssetComments from "views/asset/comments";

import Assets from "views/asset";

import LockerOpened from "views/locker/opened";

import Faq from "views/faq";

import Terms from "views/terms";

import ForbiddenPage from "views/403";
import NotFoundPage from "views/404";

const Router = () => {
  return (
    <Suspense fallback={null}>
      <BrowserRouter>
        <AxiosInterceptor>
          {/* <Layout> */}
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Navigate to="/intro" />} />
              <Route exact path="/intro" element={<Intro />} />

              <Route exact path="/login" element={<Login />} />
              <Route exact path="/validate" element={<Validate />} />
              {/* Protected Routes */}
              <Route element={<AuthGuard />}>
                <Route exact path="/home" element={<Homepage />} />

                <Route exact path="/assets" element={<Assets />} />
                <Route exact path="/owned" element={<OwnedAssets />} />
                <Route exact path="/asset/details/:id" element={<AssetDetails />} />
                <Route exact path="/asset/pickup/:id" element={<AssetPickup />} />
                <Route exact path="/asset/return/:id" element={<ReturnAsset />} />
                <Route exact path="/asset/review/:id" element={<AssetReview />} />
                <Route exact path="/asset/comments/:id" element={<AssetComments/>} />

                <Route exact path="/locker/opened" element={<LockerOpened />} />

                <Route exact path="/faq" element={<Faq />} />

                <Route exact path="/terms" element={<Terms />} />
              </Route>

              <Route exact path="/403" element={<ForbiddenPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
          {/* </Layout> */}
        </AxiosInterceptor>
      </BrowserRouter>
    </Suspense>
  );
};

export default Router;
